/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerMiniCartMenuSX: SxProps = {
	width: '300px',
};

export const headerMiniCartItemsSX: SxProps = {
	height: 'auto',
	maxHeight: '300px',
	overflowY: 'auto',
	overflowX: 'hidden',
	width : '310px',
};
